import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Loyaltic } from '../constants/api-url.constants';
import { of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CoreService {

  constructor(private http: HttpClient) { }

  signUp(userName: any) {
    return this.http.post(environment.baseUrl + Loyaltic.API.CaptureEmail, JSON.stringify({ Email: userName }))
      .toPromise().then(response => {
        return response;
      });
  }

  getLiveConfig() {
    return this.http.get(environment.baseUrl + Loyaltic.API.LiveConfig)
      .toPromise().then(response => {
        return response;
      });
  }


  emailReminder(body: any) {
    return this.http.post(environment.baseUrl + Loyaltic.API.Emailreminder, JSON.stringify(body)).toPromise().then(response => {
      return response;
    });
  }

  logIn(email: any) {
    return this.http.post(environment.baseUrl + Loyaltic.API.Login,
      JSON.stringify({ Email: email, HasOptedForMarkettingEmail: true }))
      .toPromise().then(response => {
        return response;
      });
  }

  upLoadReceipt(payload: any) {
    return this.http.post(environment.baseUrl + Loyaltic.API.Upload,
      payload)
      .toPromise().then(response => {
        return response;
      });
  }

  upLoadReceiptWithRealTimeScanning(payload: any) {
    return this.http.post(environment.baseUrl + Loyaltic.API.UploadWithRealTimeScanning,
      payload)
      .toPromise().then(response => {
        return response;
      });
  }

  RegUploadWithRealTimeScanning(payload: any) {
    return this.http.post(environment.baseUrl + Loyaltic.API.RegUploadWithRealTimeScanning,
      payload)
      .toPromise().then(response => {
        return response;
      });
  }

  loginWithUploadReceipt(payload: any) {
    return this.http.post(environment.baseUrl + Loyaltic.API.LoginWithUploadReceipt,
      payload)
      .toPromise().then(response => {
        return response;
      });
  }

  getAvailableGames(userId: any) {
    return this.http.get(environment.baseUrl + Loyaltic.API.AvailableGames + '?userid=' + userId).toPromise().then(response => {
      return response;
    });
  }

  fetchProducts(culture: any) {
    return this.http.get(environment.baseUrl + Loyaltic.API.FetchProducts + '?culture=' + culture).toPromise().then(response => {
      return response;
    });
  }

  getAvailableRewards(culture: any) {
    return this.http.get(environment.baseUrl + Loyaltic.API.AvailableRewards + '?culture=' + culture).toPromise().then(response => {
      return response;
    });
  }

  Getcodedetails(userId: any, rewardCode: any) {
    return this.http.get(environment.baseUrl + Loyaltic.API.Getcodedetails + '?userid=' + userId + '&rewardCode=' + rewardCode).toPromise().then(response => {
      return response;
    });
  }

  getRewardsCount() {
    return this.http.get(environment.baseUrl + Loyaltic.API.Awardsredeemed).toPromise().then(response => {
      return response;
    });
  }


  play(userId: any, isApproved: any) {
    return this.http.post(environment.baseUrl + Loyaltic.API.Play, JSON.stringify({ UserId: userId, Isapproved: isApproved }))
      .toPromise().then(response => {
        return response;
      });
  }

  captureAddress(body: any) {
    return this.http.post(environment.baseUrl + Loyaltic.API.CaptureAddress, JSON.stringify(body))
      .toPromise().then(response => {
        return response;
      });
  }

  captureWinEmail(body: any) {
    return this.http.post(environment.baseUrl + Loyaltic.API.CaptureWinEmail, JSON.stringify(body))
      .toPromise().then(response => {
        return response;
      });
  }

  Markcodeasredeemed(body: any) {
    return this.http.post(environment.baseUrl + Loyaltic.API.Markcodeasredeemed, JSON.stringify(body))
      .toPromise().then(response => {
        return response;
      });
  }


  CaptureWinMobile(body: any) {
    return this.http.post(environment.baseUrl + Loyaltic.API.CaptureWinMobile, JSON.stringify(body))
      .toPromise().then(response => {
        return response;
      });
  }


  confirmReceiptUpload(partitionKey: any, rowKey: any) {
    return this.http.post(environment.baseUrl +
      Loyaltic.API.confirmuploadafterscanning + '?PartitionKey=' + partitionKey + '&RowKey=' + rowKey, null)
      .toPromise().then(response => {
        return response;
      });
  }

  getCategories(culture: any) {
    return this.http.get(environment.baseUrl + Loyaltic.API.GetCategories + '?culture=' + culture).toPromise().then(response => {
      return response;
    });
  }

  getProducts(culture: any) {
    return this.http.get(environment.baseUrl + Loyaltic.API.GetProducts + '?culture=' + culture).toPromise().then(response => {
      return response;
    });
  }

  getChartData() {
    return this.http.get(environment.baseUrl + Loyaltic.API.GetChartData)
      .toPromise().then(response => {
        return response;
      });
  }

  FetchDailyParticipationDetails() {
    return this.http.get(environment.baseUrl + Loyaltic.API.FetchDailyParticipationDetails)
      .toPromise().then(response => {
        return response;
      });
  }

  FetchDailyReceiptUploadDetails() {
    return this.http.get(environment.baseUrl + Loyaltic.API.FetchDailyReceiptUploadDetails)
      .toPromise().then(response => {
        return response;
      });
  }

  FetchDailyCashbackDetails() {
    return this.http.get(environment.baseUrl + Loyaltic.API.FetchDailyCashbackDetails)
      .toPromise().then(response => {
        return response;
      });
  }

}
